"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ratio = void 0;
var Ratio = /** @class */ (function () {
    function Ratio(numerator, denominator) {
        this.numerator = numerator;
        this.denominator = denominator;
        if (numerator == null) {
            throw new Error('Cannot create a ratio with an undefined numerator');
        }
        if (denominator == null) {
            throw new Error('Cannot create a ratio with an undefined denominator');
        }
    }
    Object.defineProperty(Ratio.prototype, "isRatio", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Ratio.prototype.clone = function () {
        return new Ratio(this.numerator.clone(), this.denominator.clone());
    };
    Ratio.prototype.toString = function () {
        return "".concat(this.numerator.toString(), " : ").concat(this.denominator.toString());
    };
    Ratio.prototype.equals = function (other) {
        if (other != null && other.isRatio) {
            var divided_this = this.numerator.dividedBy(this.denominator);
            var divided_other = other.numerator.dividedBy(other.denominator);
            return divided_this === null || divided_this === void 0 ? void 0 : divided_this.equals(divided_other);
        }
        else {
            return false;
        }
    };
    Ratio.prototype.equivalent = function (other) {
        var equal = this.equals(other);
        return equal != null ? equal : false;
    };
    return Ratio;
}());
exports.Ratio = Ratio;
//# sourceMappingURL=ratio.js.map